<template>
    <div ref="loadMoreWrapper" class="loadMoreWrapper">
        <div class="loadMoreContent">
            <div :class="['load reload',{loading: reload}]" v-if="pullDown">
                <p v-if="!reload" :style="{color: 'red'}">下拉刷新</p>
                <img src="/img/flower/loading.png" v-else class="spinner"/>
            </div>
            <slot></slot>
            <div :class="['load',{loading: !loadStatus}]">
                <p v-if="loadStatus">{{allLoaded ? '无更多数据' : '加载更多...'}}</p>
                <img src="/img/flower/loading.png" v-else class="spinner"/>
            </div>
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll';

export default {
    props: ['allLoaded', 'pullDown', 'scroll'],
    data() {
        return {
            loadMoreWrapper: null,
            loadStatus: true,
            reload: false
        };
    },
    methods: {
        refresh() {
            setTimeout(() => {
                if (!this.loadMoreWrapper) {
                    this.initScroll();
                    return;
                }
                this.loadMoreWrapper.refresh();
                if (this.scroll) {
                    this.scroll({
                        x: this.loadMoreWrapper.x,
                        y: this.loadMoreWrapper.y
                    });
                }
            }, 30);
        },
        scrollTo(x, y, time) {
            this.loadMoreWrapper.scrollTo(x, y, time);
        },
        scrollToElement(el) {
            this.loadMoreWrapper.scrollToElement(el);
        },
        finishPullUp() {
            this.loadStatus = true;
            this.refresh();
        },
        finishPullDown() {
            console.log('chufa');
            this.reload = false;
            this.refresh();
        },
        initScroll() {
            this.loadMoreWrapper = new BScroll(this.$refs.loadMoreWrapper, {
                probeType: 3,
                scrollY: true,
                scrollX: false,
                click: true,
                bounceTime: 200,
                swipeTime: 1500,
                deceleration: 0.003,
                swipeBounceTime: 200,
                useTransition: false
            });

            if (this.scroll) {
                this.loadMoreWrapper.on('scroll', position => {
                    this.scroll(position);
                });
            }
            this.loadMoreWrapper.on('touchEnd', position => {
                if (position.y < (this.loadMoreWrapper.maxScrollY - 50)) {
                    if (!this.allLoaded) {
                        this.loadStatus = false;
                        this.$emit('pullingUp');
                    }
                }
                if (this.pullDown && position.y > 50) {
                    console.log('大于50啦');
                    this.reload = true;
                    this.$emit('pullingDown');
                }
            });
        }
    }
};
</script>

<style lang="stylus" scoped>
    .loadMoreWrapper
        height 100%
        overflow hidden
    .loadMoreContent
        position relative
        min-height 100.1%
        .load
            position absolute
            left 0
            bottom -50px
            width 100%
            height 50px
            transition 1s all
            z-index 9
            &.reload
                top -50px
                bottom auto
                &.loading
                    top 0
            &.loading
                bottom 0
            p
                line-height 50px
                text-align center
                font-size 12px
                color #ccc
            .spinner
                size .6rem
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)
                animation: rotate 1s infinite linear;
                transform-origin: 0 0;
</style>
